<template>
  <label
    :aria-checked="isChecked"
    :aria-disabled="isDisabled || isReadonly"
    class="s-checkbox-button"
    :class="[
      { 'is-disabled': isDisabled },
      { 'is-readonly': isReadonly },
      { 'is-checked': isChecked },
      { 'is-focus': focus },
    ]"
    role="checkbox">
    <input
      v-if="trueLabel || falseLabel"
      v-model="model"
      class="s-checkbox-button__original"
      data-qa="checkbox"
      :disabled="isDisabled || isReadonly"
      :false-value="falseLabel"
      :name="name"
      :state="isChecked ? 'check' : 'uncheck'"
      :true-value="trueLabel"
      type="checkbox"
      @blur="focus = false"
      @change="handleChange"
      @focus="focus = true">
    <input
      v-else
      v-model="model"
      class="s-checkbox-button__original"
      data-qa="checkbox"
      :disabled="isDisabled || isReadonly"
      :name="name"
      :state="isChecked ? 'check' : 'uncheck'"
      type="checkbox"
      :value="label"
      @blur="focus = false"
      @change="handleChange"
      @focus="focus = true">

    <span
      v-if="$slots.default || label"
      class="s-checkbox-button__inner"
      :style="isChecked ? activeStyle : null">
      <slot>{{ label }}</slot>
    </span>

  </label>
</template>
<script>
import Form from '../../mixins/form.js'
import emitter from '../../mixins/emitter'

/**
 * Checkbox кнопка
 * @displayName CheckboxButton
 */
export default {
  name: 'sCheckboxButton',
  mixins: [emitter, Form],
  data() {
    return {
      selfModel: false,
      focus: false,
      isLimitExceeded: false
    }
  },
  props: {
    /**
     * Значение
     */
    value: {
      type: [String, Number, Boolean],
    },
    /**
     * значение при использовании внутри группы
     */
    label: {
      type: [String, Number, Boolean],
    },
    /**
     * отключение
     */
    disabled: {
      type: Boolean,
    },
    /**
     * Только чтение
     */
    readonly: {
      type: Boolean,
    },
    checked: Boolean,
    /**
     * собственный атрибут 'name'
     */
    name: {
      type: String,
    },
    /**
     * значение, если отмечено
     */
    trueLabel: {
      type: [String, Number],
    },
    /**
     * значение, если не отмечено
     */
    falseLabel: {
      type: [String, Number],
    },
  },
  computed: {
    model: {
      get() {
        return this._checkboxGroup
          ? this.store : this.value !== undefined
            ? this.value : this.selfModel
      },
      set(val) {
        if (this._checkboxGroup) {
          this.isLimitExceeded = false;
          (this._checkboxGroup.min !== undefined &&
              val.length < this._checkboxGroup.min &&
              (this.isLimitExceeded = true));
          (this._checkboxGroup.max !== undefined &&
              val.length > this._checkboxGroup.max &&
              (this.isLimitExceeded = true))
          this.isLimitExceeded === false &&
            this.dispatch('sCheckboxGroup', 'input', [val])
        } else if (this.value !== undefined) {
          this.$emit('input', val)
        } else {
          this.selfModel = val
        }
      }
    },
    isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model
      } else if (Array.isArray(this.model)) {
        return this.model.indexOf(this.label) > -1
      } else if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel
      }
      return false
    },
    _checkboxGroup() {
      let parent = this.$parent
      while (parent) {
        if (parent.$options.componentName !== 'sCheckboxGroup') {
          parent = parent.$parent
        } else {
          return parent
        }
      }
      return false
    },
    store() {
      return this._checkboxGroup ? this._checkboxGroup.value : this.value
    },
    activeStyle() {
      return {
        backgroundColor: this._checkboxGroup.fill || '',
        borderColor: this._checkboxGroup.fill || '',
        color: this._checkboxGroup.textColor || '',
        'box-shadow': '-1px 0 0 0 ' + this._checkboxGroup.fill
      }
    },
    /* used to make the isDisabled judgment under max/min props */
    isLimitDisabled() {
      const { max, min } = this._checkboxGroup
      return !!(max || min) &&
          (this.model.length >= max && !this.isChecked) ||
          (this.model.length <= min && this.isChecked)
    },
    isDisabled() {
      return this._checkboxGroup
        ? this._checkboxGroup.disabled || this.disabled || (this.sForm || {}).disabled || this.isLimitDisabled
        : this.disabled || (this.sForm || {}).disabled
    },
    isReadonly() {
      return this._checkboxGroup
        ? this._checkboxGroup.readonly || this.readonly || (this.sForm || {}).readonly
        : this.readonly || (this.sForm || {}).readonly
    }
  },
  methods: {
    addToStore() {
      if (
        Array.isArray(this.model) &&
          this.model.indexOf(this.label) === -1
      ) {
        this.model.push(this.label)
      } else {
        this.model = this.trueLabel || true
      }
    },
    handleChange(ev) {
      if (this.isLimitExceeded) { return }
      let value
      if (ev.target.checked) {
        value = this.trueLabel === undefined ? true : this.trueLabel
      } else {
        value = this.falseLabel === undefined ? false : this.falseLabel
      }
      this.$emit('change', value, ev)
      this.$nextTick(() => {
        if (this._checkboxGroup) {
          this.dispatch('sCheckboxGroup', 'change', [this._checkboxGroup.value])
        }
      })
    }
  },
  created() {
    this.checked && this.addToStore()
  }
}
</script>